import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatWidget from "@/components/ChatWidget";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { About, Brands, Categories, SearchPage, Services, Fleet, Quotation, FAQ, Contact, Privacy, Terms } from "@/pages/Pages";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
};

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
    <ChatWidget />
  </>
);

function App() {
  return (
    <div className="App grain min-h-screen bg-[#050505]">
      <AppProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <Seo />
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/brands" element={<Layout><Brands /></Layout>} />
            <Route path="/categories" element={<Layout><Categories /></Layout>} />
            <Route path="/search" element={<Layout><SearchPage /></Layout>} />
            <Route path="/fleet" element={<Layout><Fleet /></Layout>} />
            <Route path="/quotation" element={<Layout><Quotation /></Layout>} />
            <Route path="/services" element={<Layout><Services /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
